import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { DEFAULTS } from "./defaults";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [overrides, setOverrides] = useState({});

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      setOverrides(data);
    } catch {
      /* fall back to defaults */
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const t = useCallback((k) => overrides[k] ?? DEFAULTS[k] ?? k, [overrides]);
  const list = useCallback(
    (k) => String(overrides[k] ?? DEFAULTS[k] ?? "").split("\n").map((s) => s.trim()).filter(Boolean),
    [overrides]
  );

  return (
    <ContentContext.Provider value={{ t, list, overrides, refresh }}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent() {
  return useContext(ContentContext);
}

// Renders content for key `k`; *asterisk-wrapped* segments become italic accents.
export function T({ k, em = "text-brand-green", className = "" }) {
  const { t } = useContent();
  const parts = String(t(k)).split(/\*([^*]+)\*/g);
  return (
    <span className={className}>
      {parts.map((p, i) => (i % 2 === 1 ? <em key={i} className={em}>{p}</em> : p))}
    </span>
  );
}
